// import "./App.css";
// import { Navbar } from "./Components/Navbar/Navbar";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import LoginSignup from "./Pages/LoginSignup";
// import ShopCategory from "./Pages/ShopCategory";
// import Cart from "./Pages/Cart";
// import Shop from "./Pages/Shop";
// import Product from "./Pages/Product";
// import Footer from "./Components/Footer/Footer";
// import men_banner from "./Components/Assets/Assets/banner_mens.png";
// import women_banner from "./Components/Assets/Assets/banner_women.png";
// import kid_banner from "./Components/Assets/Assets/banner_kids.png";

// function App() {
//   return (
//     <div>
//       <BrowserRouter>
//         <Navbar />
//         <Routes>
//           <Route path="/" element={<Shop />} />
//           <Route
//             path="/mens"
//             element={<ShopCategory banner={men_banner} category="men" />}
//           />
//           <Route
//             path="/womens"
//             element={<ShopCategory banner={women_banner} category="women" />}
//           />
//           <Route
//             path="/kids"
//             element={<ShopCategory banner={kid_banner} category="kid" />}
//           />

//           <Route path="/product/:productId" element={<Product />}>

//           <Route path="/cart" element={<Cart />} />
//           <Route path="/login" element={<LoginSignup />} />
//         </Routes>
//       </BrowserRouter>
//       {/* <Footer /> */}
//     </div>
//   );
// }

// export default App;
import "./App.css";
import { Navbar } from "./Components/Navbar/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginSignup from "./Pages/LoginSignup";
import ShopCategory from "./Pages/ShopCategory";
import Cart from "./Pages/Cart";
import Shop from "./Pages/Shop";
import Product from "./Pages/Product";
import Footer from "./Components/Footer/Footer";
import men_banner from "./Components/Assets/Assets/banner_mens.png";
import women_banner from "./Components/Assets/Assets/banner_women.png";
import kid_banner from "./Components/Assets/Assets/banner_kids.png";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Shop />} />
          <Route
            path="/mens"
            element={<ShopCategory banner={men_banner} category="men" />}
          />
          <Route
            path="/womens"
            element={<ShopCategory banner={women_banner} category="women" />}
          />
          <Route
            path="/kids"
            element={<ShopCategory banner={kid_banner} category="kid" />}
          />
          <Route path="/product/:productId" element={<Product />} /> // Adjusted
          the product route here
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={<LoginSignup />} />
        </Routes>
      </BrowserRouter>
      {/* <Footer /> Uncomment this if you want the footer to be displayed */}
    </div>
  );
}

export default App;
